import { PostDto } from '../../../../shared/api';
import { TupleOf } from '../../../../shared/types';
import { clsx } from 'clsx';
import styles from './styles.module.scss';
import { ImageLink } from './image-link';

type Props = {
  className?: string;
  posts: TupleOf<PostDto, 8>;
};

export function Layout8(props: Props) {
  const { posts, className } = props;

  return (
    <div className={clsx(styles['layout-8'], className)}>
      <div className={styles['layout-8__col']}>
        <ImageLink
          sizes="(max-width: 600px) 300px, 400px"
          className={clsx(styles['layout-8__item'], styles['layout-8__item-1'])}
          post={posts[0]}
        />
        <ImageLink
          sizes="(max-width: 600px) 200px, 300px"
          className={clsx(styles['layout-8__item'], styles['layout-8__item-2'])}
          post={posts[1]}
        />
      </div>
      <div className={styles['layout-8__col']}>
        <ImageLink
          sizes="(max-width: 600px) 200px, 300px"
          className={clsx(styles['layout-8__item'], styles['layout-8__item-3'])}
          post={posts[2]}
        />
        <ImageLink
          sizes="(max-width: 600px) 200px, 300px"
          className={clsx(styles['layout-8__item'], styles['layout-8__item-4'])}
          post={posts[3]}
        />
      </div>
      <div className={styles['layout-8__col']}>
        <ImageLink
          sizes="(max-width: 600px) 200px, 300px"
          className={clsx(styles['layout-8__item'], styles['layout-8__item-5'])}
          post={posts[4]}
        />
        <ImageLink
          sizes="(max-width: 600px) 200px, 300px"
          className={clsx(styles['layout-8__item'], styles['layout-8__item-6'])}
          post={posts[5]}
        />
      </div>
      <div className={styles['layout-8__col']}>
        <ImageLink
          sizes="(max-width: 600px) 200px, 300px"
          className={clsx(styles['layout-8__item'], styles['layout-8__item-7'])}
          post={posts[6]}
        />
        <ImageLink
          sizes="(max-width: 600px) 200px, 300px"
          className={clsx(styles['layout-8__item'], styles['layout-8__item-8'])}
          post={posts[7]}
        />
      </div>
    </div>
  );
}
